/**
 *
 * Notes: May, 2019
 * Original source code pulled (and edited) from previous website.
 * Assuming this was custom developed by previous vendor since license was not provided.
 *
 */

import $ from "jquery";

export default RuleSeventyTwoCalculator;

function RuleSeventyTwoCalculator (o) {

    let $container = $(o),
        $form = null,
        $solve = null,
        $term = null,
        $interest = null;

        $form = $container.find("form");
        $solve = $form.find("input[name=solve]");
        $term = $form.find("input[name=term]");
        $interest = $form.find("input[name=interest]");

    $solve.change(function(e) {
        let c = e.target.defaultValue;

        $term.val("");
        $interest.val("");

        if (c === "interest") {
            $interest.focus();
            $interest.prop("readonly", false);
            $term.prop("readonly", true);
        } else {
            $term.focus();
            $term.prop("readonly", false);
            $interest.prop("readonly", true);
        }

    });

    $container.find("button[type='reset']").on('click',function(){
        $('.calc-results').addClass('hidden');

        $term.prop("readonly", false);
        $interest.prop("readonly", true);
        $term.focus();
    });


    $form.submit(function(e) {

        let checked = $form.find('input[name=solve]:checked'),
            v;

        if (checked[0].defaultValue === "term") {
            v = parseFloat($term.val());
            v = 72/v;
            v = Math.round(v * 100)/100;
            $interest.val(v);
        } else {
            v = parseFloat($interest.val().replace("%", ""));
            v = 72/v;
            v = Math.round(v * 100)/100;
            $term.val(v);
        }

        e.preventDefault();
        return false;

    });

}


// WEBPACK FOOTER //
// ./src/calculators/rule-of-72.js